import { ProfileMenuItemProps } from '@/components/app/profile/ProfileMenuItem/types';
import CCIcon from 'icons/credit-card.svg';
import GlobeIcon from 'icons/globe-outline.svg';
import LockIcon from 'icons/lock-outline.svg';
import LogoutIcon from 'icons/logout.svg';
import PlayIcon from 'icons/play-playing.svg';
import ProfileIcon from 'icons/profile-outline.svg';
import SettingsIcon from 'icons/settings-outline.svg';

import messages from './messages';

export const profileItems: Omit<ProfileMenuItemProps, 'colors'>[] = [
	{
		name: messages.myStats,
		route: '/app/profile/stats',
		Icon: PlayIcon,
	},
	{
		name: messages.mySubscription,
		route: '/app/profile/manage-subscription',
		Icon: CCIcon,
	},
	{
		name: messages.myAccountSettings,
		route: process.env.NEXT_PUBLIC_ACCOUNTS_URL,
		Icon: SettingsIcon,
		shouldOpenInNewTab: true,
	},
	{
		name: messages.myAccountDetails,
		route: '/app/profile/update-user',
		Icon: ProfileIcon,
	},
	{
		name: messages.changePassword,
		route: '/app/profile/change-password',
		Icon: LockIcon,
	},
	{
		name: messages.myLanguage,
		route: '/app/profile/language',
		Icon: GlobeIcon,
	},
	{
		name: messages.logout,
		isLogout: true,
		Icon: LogoutIcon,
	},
];
